import React, { useState, useEffect } from 'react';
import { Linkedin } from 'lucide-react';
import { leadershipData } from '../mock';

export const Leadership = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, { threshold: 0.1 });

    const section = document.querySelector('#leadership');
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="leadership" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="heading-1">{leadershipData.title}</h2>
          <div className="gold-line" style={{ margin: '24px auto' }} />
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>{leadershipData.subtitle}</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '40px', marginBottom: '60px' }}>
          {leadershipData.leaders.map((leader, index) => (
            <div key={index} style={{ opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(40px)', transition: `all 0.8s ease ${index * 0.1}s` }}>
              <div className="card-hover" style={{ background: 'var(--bg-secondary)', aspectRatio: '4/5', marginBottom: '24px', overflow: 'hidden', position: 'relative', borderRadius: '12px' }}>
                {leader.image && !leader.image.includes('placeholder') ? (
                  <img 
                    src={leader.image} 
                    alt={leader.name} 
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      objectFit: 'cover', 
                      objectPosition: leader.imagePosition || 'center top'
                    }} 
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-light)', fontSize: '14px', textAlign: 'center', padding: '20px' }}>Portrait placeholder</div>
                )}
              </div>
              <h3 className="heading-3" style={{ marginBottom: '8px' }}>{leader.name}</h3>
              <p className="body-small" style={{ color: 'var(--accent-gold)', marginBottom: '12px', fontWeight: 600 }}>{leader.title}</p>
              <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '16px', lineHeight: '1.5', minHeight: '48px' }}>{leader.description}</p>
              {leader.linkedin && (
                <a href={leader.linkedin} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', color: 'var(--interactive-base)', textDecoration: 'none', transition: 'color 0.2s ease' }} className="body-small">
                  <Linkedin size={16} />
                  Connect on LinkedIn
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};